import React, { useEffect, useMemo, useRef, useState } from "react";
import SideNavLayout from "../customsidenav/sidenavlayout";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import calendericon from "../assets/auth/calendericon.svg";
import Filtericon from "../../src/assets/Reports/FilterReport.svg";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import dayjs from "dayjs";
import { DateCalendar, LocalizationProvider } from "@mui/x-date-pickers";
import FastRewindIcon from '@mui/icons-material/FastRewind';
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { customObjectToDateString } from "../dateutils/date";
import { Backdrop, CircularProgress, styled, Typography } from "@mui/material";
import { leftarrow, rightarrow } from "../colorcoding/svg/iconsvg";
import Reporttable from "./Reporttable";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import PaymentIcon from '@mui/icons-material/Payment';
import DateRangeSelector from "../daterangepicker/DateRangeSelector";
import api from "../api/api";
import CloseIcon from "@mui/icons-material/Close";
import Filtermodal from "./Filtermodal";
import Payments from "../signin/popups/Payments";
import { useDispatch, useSelector } from "react-redux";
import ReportPaymentModal from "./reportspaymentmodal";
import { showToast } from "../reduxtoolkit/toastslice";
import { getPracticeId, hasMultipleDepartments, practiceShortName, practiceFeaturesB6, reportsCardChipMethods } from "../config/practice";
import { generatePaymentReportPdf } from "./paymentReportPdf";
import { filterLocationsFor, filterOffersAll, locationFilterDefault } from "../utils/workingLocation";
const CustomDateCalendar = styled(DateCalendar)(({ theme }) => ({
  "& .MuiPickersCalendarHeader-label": {
    fontSize: "15px",
  },
}));
const Reporthome = () => {
  const [loading, setLoading] = useState(false);
  const [isCalendarOpen, setIsCalendarOpen] = useState(false);
  const showdate = useRef();
  const [selectedDate, setSelectedDate] = useState(dayjs());
  const [dateRange, setDateRange] = useState("");
  const [selectedUser, setSelectedUser] = useState("");
  const [recordSearch, setRecordSearch] = useState("");
  const [checkMethod, setCheckMethod] = useState([]);
  const [checkLoca, setCheckLoca] = useState([]);
  const [selectedcard, setSelectedCard] = useState({});
  const [checkSta, setCheckSta] = useState([]);
  const [userList, setUserList] = useState([]);
  const practiseid = getPracticeId();
  // OSA batch 6: the PDF button and OSA's slimmer page (7825); 9928: off.
  const b6 = practiceFeaturesB6();
const dispatch=useDispatch()
  const paymentprev = useSelector(
            (state) => state.userPrivileges.Payment
          );
  const calendarRef = useRef(null);
  const [filterData, setFilteredData] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [preAppointments, setPreAppointments] = useState("t");
  const [totalData, setTotalData] = useState([]);
  const [filterPopup, SetIsFilterPopup] = useState(false);
  const [paymentModal, setpaymentModal] = useState(false);
  const [isdeletedRecords, setIsDeletedRecords] = useState(false);
  const [isRequested,setIsRequested]=useState(false)
  const [deleteloading, setDeleteLoading] = useState(false);
  const [data, setData] = useState([]);
    const userConfig = useSelector((state) => state.userconfig);
    // Department filter — defaults to the header's location; "" = all
    // (QA 2026-08-27: both departments' charges were mixed in one report).
    // "All locations" in the header (all_departments logins) -> "".
    const [deptFilter, setDeptFilter] = useState(undefined);
    useEffect(() => {
      if (deptFilter === undefined && userConfig?.config) {
        setDeptFilter(locationFilterDefault(userConfig.config));
      }
    }, [userConfig, deptFilter]);
  const [selectedDateRange, setSelectedDateRange] = useState({
    startDate: new Date(),
    endDate: new Date(),
    key: "selection",
  });
  const skipEffect = useRef(false);
  const [paymentMethodList, setPaymentMethodList] = useState([]);
  
  const excludedPatientIds = [2336, 1468, 12241];
  const { squareAmount, cashAmount } = useMemo(() => {
    // Payment methods in the red card chip: [1, 2], or the practice's own
    // list (7825: [1, 2, 3, 6] -- its kiosk card payments are method 6).
    const cardChipMethods = reportsCardChipMethods();
    const filteredData = data.filter(
      (item) => !excludedPatientIds.includes(Number(item.patientid))
    );
    const square = filteredData.reduce((acc, x) => {
      const method = Number(x.payment_method);
      if (cardChipMethods.includes(method)) return acc + (x.amount || 0);
      return acc;
    }, 0);
    const cash = filteredData.reduce((acc, x) => {
      if (x.type === "CASH") return acc + (x.amount || 0);
      return acc;
    }, 0);
    return { squareAmount: square, cashAmount: cash };
  }, [data]);

  // Example data for the dropdowns
  const dateRanges = [
    "Last 7 Days",
    "Last 30 Days",
    "This Month",
    "Last Month",
  ];
  const isTodayRange = () => {
    const today = dayjs().format("YYYY-MM-DD");

    const start = dayjs(selectedDateRange.startDate).format("YYYY-MM-DD");
    const end = dayjs(selectedDateRange.endDate).format("YYYY-MM-DD");

    return start === today && end === today;
  };
  const ClosePaymentModal = () => {
    setpaymentModal(false);
    setSelectedCard("");
  };
  
  const fetchTotalData = async (a) => {
    const dateRange = a || selectedDateRange;

    const formattedStartDate = dayjs(dateRange.startDate).format("YYYY-MM-DD");
    const formattedEndDate = dayjs(dateRange.endDate).format("YYYY-MM-DD");

    try {
      let payload = {
        startDate: formattedStartDate,
        endDate: formattedEndDate,
        recordSearch: "",
        userfilter: "",
        checkMethod: [],
        checkLoca: [],
        checkSta: [],
        isPastAppt: "",
        departmentid: deptFilter || undefined,
      };

      let response = await api.post(`/v1/${practiseid}/reports/get`, payload);

      if (response.status === 200) {
        let filteredData = response.data.filter(
          (item) => item.patientid !== 2336 && item.patientid !== 1468 && item.patientid !== 7114,
        );
    
// if (isdeletedRecords) {
//   filteredData = filteredData.filter(item => item.status === 0);
// } else {
//   filteredData = filteredData.filter(item => item.status !== 0);
// }
// if (isRequested) {
//   filteredData = filteredData.filter(
//     (item) =>
//       item.status !== 0 &&
//       item.delete_request_by &&
//       item.delete_request_by.trim() !== ""
//   );
// }
// Delete filtering logic
// if (isdeletedRecords && isRequested) {
//   filteredData = filteredData.filter(
//     item =>
//       item.status === 0 ||
//       (item.status !== 0 &&
//         item.delete_request_by &&
//         item.delete_request_by.trim() !== "")
//   );

// } else if (isdeletedRecords) {
//   filteredData = filteredData.filter(item => item.status === 0);

// } else if (isRequested) {
//   filteredData = filteredData.filter(
//     item =>
//       item.status !== 0 &&
//       item.delete_request_by &&
//       item.delete_request_by.trim() !== ""
//   );

// } else {
//   filteredData = filteredData.filter(
//     item =>
//       item.status !== 0 &&
//       (!item.delete_request_by || item.delete_request_by.trim() === "")
//   );
// }
        if (isdeletedRecords && isRequested) {
  filteredData = filteredData.filter(
    item =>
      item.status === 0 ||
      (item.status !== 0 &&
        item.delete_request_by &&
        item.delete_request_by.trim() !== "")
  );
} else if (isdeletedRecords) {
  filteredData = filteredData.filter(
    item => Number(item.status) === 0
  );
} else if (isRequested) {
  filteredData = filteredData.filter(
    item =>
      Number(item.status) !== 0 &&
      item.delete_request_by &&
      item.delete_request_by.trim() !== ""
  );
} else {
  filteredData = filteredData.filter(
    item =>
      Number(item.status) !== 0 &&
      (!item.delete_request_by ||
        item.delete_request_by.trim() === "")
  );
}
        setTotalData(filteredData);
      } else {
        setTotalData([]);
      }
    } catch (err) {
      console.log(err);
    }
  };
  const handledateSelect = () => {
    fetchdata(selectedDateRange); // Only fetch data when "Apply" button is clicked
    fetchTotalData(selectedDateRange);
    setIsCalendarOpen(false); // Close the calendar after apply
  };

  const handleDateRangeSelect = (selectedRange) => {
    let startDate, endDate;

    switch (selectedRange) {
      case "Last 7 Days":
        startDate = dayjs().subtract(7, "days").toDate();
        endDate = new Date();
        break;
      case "Last 30 Days":
        startDate = dayjs().subtract(30, "days").toDate();
        endDate = new Date();
        break;
      case "This Month":
        startDate = dayjs().startOf("month").toDate();
        endDate = dayjs().endOf("month").toDate();
        break;
      case "Last Month":
        startDate = dayjs().subtract(1, "month").startOf("month").toDate();
        endDate = dayjs().subtract(1, "month").endOf("month").toDate();
        break;
      default:
        startDate = new Date();
        endDate = new Date();
    }

    // Update the state for the selected date range
    setSelectedDateRange({ startDate, endDate, key: "selection" });
    setDateRange(selectedRange); // Update the dropdown value
    fetchdata({ startDate, endDate }); // Fetch data based on new date range
    fetchTotalData({ startDate, endDate });
  };

  const fetchdata = async (a) => {
    const dateRange = a || selectedDateRange;
    const formattedStartDate = dayjs(dateRange.startDate).format("YYYY-MM-DD");
    const formattedEndDate = dayjs(dateRange.endDate).format("YYYY-MM-DD");
    showdate.current = dayjs(dateRange.startDate).format("YYYY-MM-DD");

    try {
      setLoading(true);
      console.log(formattedStartDate, "formmm");
      // Prepare the payload with the necessary fields
      let payload = {
        startDate: formattedStartDate,
        endDate: formattedEndDate,
        recordSearch: recordSearch, // This will be set based on button clicks (Insurance/Self Pay)
        userfilter: selectedUser, // Pass userfilter (if applicable)
        checkMethod: checkMethod, // Wrap checkMethod in an array, even if empty
        checkLoca: checkLoca, // Wrap checkLoca in an array, even if empty
        checkSta: checkSta,
        isPastAppt: preAppointments, // Wrap checkSta in an array, even if empty
        departmentid: deptFilter || undefined,
      };

      // Send the request with the prepared payload
      let response = await api.post(`/v1/${practiseid}/reports/get`, payload);

      if (response.status === 200) {
        let filteredData = response.data.filter(
          (item) => item.patientid !== 2336 && item.patientid !== 1468  && item.patientid !== 7114,
        );
//         if (isdeletedRecords) {
//           filteredData = filteredData.filter((item) => item.status === 0);
//         } else {
//   filteredData = filteredData.filter(item => item.status !== 0);
// }
// if (isRequested) {
//   filteredData = filteredData.filter(
//     (item) =>
//       item.status !== 0 &&
//       item.delete_request_by &&
//       item.delete_request_by.trim() !== ""
//   );
// }
// Delete filtering logic

// if (isdeletedRecords && isRequested) {
//   filteredData = filteredData.filter(
//     item =>
//       item.status === 0 ||
//       (item.status !== 0 &&
//         item.delete_request_by &&
//         item.delete_request_by.trim() !== "")
//   );

// } else if (isdeletedRecords) {
//   filteredData = filteredData.filter(item => item.status === 0);

// } else if (isRequested) {
//   filteredData = filteredData.filter(
//     item =>
//       item.status !== 0 &&
//       item.delete_request_by &&
//       item.delete_request_by.trim() !== ""
//   );

// } else {
//   filteredData = filteredData.filter(
//     item =>
//       item.status !== 0 &&
//       (!item.delete_request_by || item.delete_request_by.trim() === "")
//   );
// }

if (isdeletedRecords && isRequested) {
  filteredData = filteredData.filter(
    item =>
      item.status === 0 ||
      (item.status !== 0 &&
        item.delete_request_by &&
        item.delete_request_by.trim() !== "")
  );
} else if (isdeletedRecords) {
  filteredData = filteredData.filter(
    item => Number(item.status) === 0
  );
} else if (isRequested) {
  filteredData = filteredData.filter(
    item =>
      Number(item.status) !== 0 &&
      item.delete_request_by &&
      item.delete_request_by.trim() !== ""
  );
} else {
  filteredData = filteredData.filter(
    item =>
      Number(item.status) !== 0 &&
      (!item.delete_request_by ||
        item.delete_request_by.trim() === "")
  );
}
        // Perform search filtering if there is a search term
        if (searchTerm) {
          const searchLower = searchTerm.toLowerCase();
          filteredData = filteredData.filter((item) => {
            const patientName = item.patient_name.toLowerCase(); // Use patient_name
            const idString = String(item.patientid).toLowerCase(); // Use patientid
            return (
              patientName.includes(searchLower) ||
              idString.includes(searchLower)
            );
          });
        }

        setData(filteredData);
      } else {
        setData([]); // Clear data if the response status is not 200
      }
    } catch (error) {
      console.log(error); // Log any error that occurs
    } finally {
      setLoading(false); // Stop the loading spinner when done
    }
  };

  const fetchPaymentMethods = async () => {
    try {
      const res = await api.get(`/v1/${practiseid}/payments/payment-methods`);
      if (res.status === 200) {
        setPaymentMethodList(res.data);
      }
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    document.title = `${practiceShortName()} - Reports`;
    fetchPaymentMethods();
  }, []);
  const fetchMethdata = async ({ PayLocation, PayMethod }) => {
    const dateRange = selectedDateRange;
    const formattedStartDate = dayjs(dateRange.startDate).format("YYYY-MM-DD");
    const formattedEndDate = dayjs(dateRange.endDate).format("YYYY-MM-DD");
    showdate.current = dayjs(dateRange.startDate).format("YYYY-MM-DD");

    try {
      setLoading(true);

      // Prepare the payload with the necessary fields
      let payload = {
        startDate: formattedStartDate,
        endDate: formattedEndDate,
        recordSearch: recordSearch, // This will be set based on button clicks (Insurance/Self Pay)
        userfilter: selectedUser, // Pass userfilter (if applicable)
        checkMethod: PayMethod || [], // Wrap checkMethod in an array, even if empty
        checkLoca: PayLocation || [], // Wrap checkLoca in an array, even if empty
        checkSta: checkSta,
        isPastAppt: preAppointments, // Wrap checkSta in an array, even if empty
        departmentid: deptFilter || undefined,
      };

      // Send the request with the prepared payload
      let response = await api.post(`/v1/${practiseid}/reports/get`, payload);

      if (response.status === 200) {
        let filteredData = response.data;

        // Perform search filtering if there is a search term
        if (searchTerm) {
          const searchLower = searchTerm.toLowerCase();
          filteredData = filteredData.filter((item) => {
            const patientName = item.patient_name.toLowerCase(); // Use patient_name
            const idString = String(item.patientid).toLowerCase(); // Use patientid
            return (
              patientName.includes(searchLower) ||
              idString.includes(searchLower)
            );
          });
        }

        setData(filteredData);
      } else {
        setData([]); // Clear data if the response status is not 200
      }
    } catch (error) {
      console.log(error); // Log any error that occurs
    } finally {
      setLoading(false); // Stop the loading spinner when done
    }
  };

  const handleRecordSearchClick = (value) => {
    setRecordSearch(value); // Either "insurance" or "selfpay"
    // Trigger fetch with updated filters
  };

  const handleClearClick = () => {
    setRecordSearch(""); // Reset the filter
    setCheckMethod([]);
    setCheckLoca([]);
    setCheckSta([]);
    setRecordSearch("");
    setPreAppointments("");
  };

  const handleCheckMethodClick = (method) => {
    if (checkMethod.includes(method)) {
      // Remove the method from the array if it's already selected
      setCheckMethod((prev) => prev.filter((sta) => sta !== method));
    } else {
      // Add the method to the array if it's not already selected
      setCheckMethod((prev) => [...prev, method]);
    }
  };

  const handleCheckLocaClick = (location) => {
    // STRIPE virtual logic
    if (location === "stripe") {
      const hasKiosk = checkLoca.includes("kiosk");
      const hasOnline = checkLoca.includes("online");

      if (hasKiosk && hasOnline) {
        // remove both
        setCheckLoca((prev) =>
          prev.filter((l) => l !== "kiosk" && l !== "online"),
        );
      } else {
        // force add both
        setCheckLoca((prev) => {
          const newSet = new Set(prev);
          newSet.add("kiosk");
          newSet.add("online");
          return Array.from(newSet);
        });
      }

      return;
    }

    // NORMAL toggle
    if (checkLoca.includes(location)) {
      setCheckLoca(checkLoca.filter((l) => l !== location));
    } else {
      setCheckLoca([...checkLoca, location]);
    }
  };

  const handleUserChange = (user) => {
    setSelectedUser(user);
    console.log("User", user);
  };

  const handlePreappointment = (preApp) => {
    // If 'p' is clicked, toggle between 'p' and 't'
    setPreAppointments((prev) => (prev === "p" ? "t" : "p"));
  };

  const handleCheckStaClick = (status) => {
    if (checkSta.includes(status)) {
      setCheckSta(checkSta.filter((sta) => sta !== status)); // Remove the status if it's already selected
    } else {
      setCheckSta([...checkSta, status]); // Add the new status if not selected
    }
  };

  useEffect(() => {
    if (skipEffect.current) {
      skipEffect.current = false;
      return;
    }

    if (deptFilter === undefined) return;
    fetchdata();
  }, [
    selectedDate,
    recordSearch,
    selectedUser,
    deptFilter,
    searchTerm,
    checkLoca,
    checkMethod,
    checkSta,
    preAppointments,
    isdeletedRecords,
     isRequested ,
  ]);

  const CloseFiltermodal = () => {
    SetIsFilterPopup(false);
  };
  const onclearfilters = () => {
    // Reset all filter states
    setCheckMethod([]);
    setCheckLoca([]);
    setCheckSta([]);
    setRecordSearch("");
    setPreAppointments("");
setIsRequested(false)
    // Close the filter modal and refresh the data
    SetIsFilterPopup(false);
    fetchdata(); // Re-fetch data based on cleared filters
  };
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        isCalendarOpen &&
        calendarRef.current &&
        !calendarRef.current.contains(event.target)
      ) {
        setIsCalendarOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isCalendarOpen]);

  const buildFilterChips = () => {
    const chips = [];

    // DATE CHIP
    if (!isTodayRange()) {
      const start = dayjs(selectedDateRange.startDate).format("MM-DD-YYYY");
      const end = dayjs(selectedDateRange.endDate).format("MM-DD-YYYY");

      const label = start === end ? start : `${start} - ${end}`;

      chips.push({
        label: `Date: ${label}`,
        type: "date",
      });
    }
    if (isdeletedRecords) {
      chips.push({
        label: "Archived",
        type: "archived",
      });
    }   if (isRequested) {
      chips.push({
        label: "Delete-Requests",
        type: "Delete-Requests",
      });
    }

    // RECORD SEARCH
    if (recordSearch === "insurance") {
      chips.push({
        label: "Type: Insurance",
        type: "recordSearch",
        value: "insurance",
      });
    }

    if (recordSearch === "selfpay") {
      chips.push({
        label: "Type: Self Pay",
        type: "recordSearch",
        value: "selfpay",
      });
    }

    // USER
    if (selectedUser) {
      const user = userList.find((u) => u.id === selectedUser);
      if (user) {
        chips.push({
          label: `User: ${user.firstname} ${user.lastname}`,
          type: "user",
          value: selectedUser,
        });
      }
    }

    // PAYMENT METHOD
    checkMethod.forEach((id) => {
      const method = paymentMethodList.find((m) => m.id === id);

      let label = "";

      if (id === 6) {
        label = "Credit/Debit Card";
      } else if (id === 3) {
        label = "Care Credit";
      } else if (method) {
        label = method.method;
      } else {
        label = id;
      }

      chips.push({
        label: `${label}`,
        type: "method",
        value: id,
      });
    });

    // LOCATION (Stripe logic)
    const hasKiosk = checkLoca.includes("kiosk");
    const hasOnline = checkLoca.includes("online");

    // Stripe = kiosk + online
    if (hasKiosk && hasOnline) {
      chips.push({
        label: "Stripe",
        type: "location",
        value: "stripe",
      });
    } else {
      if (hasKiosk) {
        chips.push({
          label: "Kiosk",
          type: "location",
          value: "kiosk",
        });
      }

      if (hasOnline) {
        chips.push({
          label: "Online",
          type: "location",
          value: "online",
        });
      }
    }

    // Square
    if (checkLoca.includes("front")) {
      chips.push({
        label: "Square",
        type: "location",
        value: "front",
      });
    }

    // STATUS
    checkSta.forEach((s) =>
      chips.push({
        label: `${s}`,
        type: "status",
        value: s,
      }),
    );

    // PAST APPOINTMENTS
    if (preAppointments === "p") {
      chips.push({
        label: "Appointment: Past",
        type: "pre",
        value: "p",
      });
    }

    return chips;
  };
  const removeChip = (chip) => {
    switch (chip.type) {
      case "archived":
      setIsDeletedRecords((prev) => !prev);
        break;
        case 'Delete-Requests':
        setIsRequested(false)
        break;
      case "recordSearch":
        setRecordSearch("");
        break;

      case "user":
        setSelectedUser("");
        break;

      case "method":
        setCheckMethod((prev) => prev.filter((m) => m !== chip.value));
        break;

      case "location":
        if (chip.value === "stripe") {
          setCheckLoca((prev) =>
            prev.filter((l) => l !== "kiosk" && l !== "online"),
          );
        } else {
          setCheckLoca((prev) => prev.filter((l) => l !== chip.value));
        }
        break;

      case "status":
        setCheckSta((prev) => prev.filter((s) => s !== chip.value));
        break;

      case "pre":
        setPreAppointments("t");
        break;

      case "date":
        const today = new Date();
        setSelectedDateRange({
          startDate: today,
          endDate: today,
          key: "selection",
        });
        const newRange = {
          startDate: today,
          endDate: today,
          key: "selection",
        };
        skipEffect.current = true;
        setSelectedDate(dayjs());
        fetchdata(newRange);
        fetchTotalData(newRange);

        return;
    }

    // setTimeout(() => fetchdata(), 0);
  };
  // useEffect(()=>{
  //  if(!checkLoca.length&&!checkMethod.length&&!checkSta.length){
  //    fetchdata()
  //  }
  // },[checkLoca,checkMethod,checkSta])

  const onapplyfilters = () => {
    // Call the fetchdata function to reload the data with the selected filters
    // fetchdata();
    SetIsFilterPopup(false);
  };

  const fetchUserData = async () => {
    setLoading(true); // Start loading
    try {
      const response = await api.get(`/v1/${practiseid}/reports/users`);
      if (response.status === 200) {
        setUserList(response.data); // Set data to user list
      } else {
        setUserList([]); // Clear user list in case of failure
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false); // Stop loading
    }
  };

  useEffect(() => {
    fetchUserData();
  }, []);
const handledelete = async (item) => {
  try {
    setDeleteLoading(true);

    const response = await api.post(
      `v1/${practiseid}/patient-payments/${item.payment_id}/delete`
    );

    if (response.status === 200) {

setData(prev => {
  if (isdeletedRecords) {
    return prev.map(row =>
      row.payment_id === item.payment_id
        ? { ...row, status: 0, delete_request_by: "" }
        : row
    );
  }

  return prev.filter(row => row.payment_id !== item.payment_id);
});

setTotalData(prev =>
  prev.map(row =>
    row.payment_id === item.payment_id
      ? { ...row, status: 0, delete_request_by: "" }
      : row
  )
);

      dispatch(
        showToast({
          message: response.message,
          severity: "success",
        })
      );

    } else {
      dispatch(
        showToast({
          message: response.message || "Something went wrong",
          severity: "info",
        })
      );
    }

  } catch (error) {
    console.log(error);
    dispatch(
      showToast({
        message: "Something went wrong",
        severity: "error",
      })
    );
  } finally {
    setDeleteLoading(false);
  }
};

const handlerequest=async(reason,item)=>{
try {
  setDeleteLoading(true)
const response = await api.post(
  `/v1/${practiseid}/payment/${item.payment_id}/delete_request`,
  null,
  {
    params: {
      request_reason: reason,
      requestedby: userConfig.username
    }
  }
);
 if (response.status === 200) {

      // update row locally
      const updatedRow = {
        ...item,
        delete_request_by: userConfig.username
      };

      setData(prev =>
        prev
          .map(row =>
            row.payment_id === item.payment_id ? updatedRow : row
          )
          // .filter(row => !row.delete_request_by) // remove from normal list
      );

      setTotalData(prev =>
        prev
          .map(row =>
            row.payment_id === item.payment_id ? updatedRow : row
          )
          // .filter(row => !row.delete_request_by)
      );

      dispatch(
        showToast({
          message: "Delete request sent",
          severity: "success"
        })
      );
    }
} catch (error) {
  console.log(error)
      dispatch(
      showToast({
        message: "Something went wrong",
        severity: "error",
      })
    );
}finally{
setDeleteLoading(false)
}
}


  useEffect(() => {
    // Totals must follow the department filter too — they fetched once on
    // mount (before the dept default even loaded) and never refetched, so
    // the cards mixed Odessa+Frisco while the table was filtered
    // (QA 2026-08-28).
    if (deptFilter === undefined) return;
    fetchTotalData();
  }, [isdeletedRecords, isRequested, deptFilter]);
  // useEffect(() => {
  //   if (!filterPopup) {
  //     setCheckMethod([]);
  //     setCheckLoca([]);
  //     setCheckSta([]);
  //     setPreAppointments('');
  //   }
  // }, [filterPopup]);
  const handlePrevDate = (e) => {
    e.stopPropagation();
    setSelectedDate((prev) => prev.subtract(1, "day"));

    setSelectedDateRange((prev) => ({
      ...prev,
      startDate: dayjs(prev.startDate).subtract(1, "day").toDate(),
      endDate: dayjs(prev.endDate).subtract(1, "day").toDate(),
    }));

    fetchdata({
      startDate: dayjs(selectedDateRange.startDate).subtract(1, "day").toDate(),
      endDate: dayjs(selectedDateRange.endDate).subtract(1, "day").toDate(),
    });
    fetchTotalData({
      startDate: dayjs(selectedDateRange.startDate).subtract(1, "day").toDate(),
      endDate: dayjs(selectedDateRange.endDate).subtract(1, "day").toDate(),
    });
  };

  const handleNextDate = (e) => {
    e.stopPropagation();
    setSelectedDate((prev) => prev.add(1, "day"));

    setSelectedDateRange((prev) => ({
      ...prev,
      startDate: dayjs(prev.startDate).add(1, "day").toDate(),
      endDate: dayjs(prev.endDate).add(1, "day").toDate(),
    }));

    fetchdata({
      startDate: dayjs(selectedDateRange.startDate).add(1, "day").toDate(),
      endDate: dayjs(selectedDateRange.endDate).add(1, "day").toDate(),
    });
    fetchTotalData({
      startDate: dayjs(selectedDateRange.startDate).subtract(1, "day").toDate(),
      endDate: dayjs(selectedDateRange.endDate).subtract(1, "day").toDate(),
    });
  };
  // Reports > PDF (OSA batch 6). The libraries load on the first click.
  const [pdfBusy, setPdfBusy] = useState(false);
  const handlePaymentReportPdf = async () => {
    if (!data.length || pdfBusy) return;
    setPdfBusy(true);
    try {
      await generatePaymentReportPdf({
        data,
        startDate: selectedDateRange.startDate,
        endDate: selectedDateRange.endDate,
        cashAmount,
        cardAmount: squareAmount,
        excludedPatientIds,
        practiceName: practiceShortName(),
      });
    } catch (error) {
      console.error("Payment report PDF failed:", error);
      dispatch(showToast({ message: "Could not create the PDF", severity: "error" }));
    } finally {
      setPdfBusy(false);
    }
  };

  const updatedata = (updatedRow) => {
    setData((prev) =>
      prev.map((item) =>
        item.payment_id === updatedRow.payment_id
          ? { ...item, ...updatedRow }
          : item,
      ),
    );

    setTotalData((prev) =>
      prev.map((item) =>
        item.payment_id === updatedRow.payment_id
          ? { ...item, ...updatedRow }
          : item,
      ),
    );
  };

  return (
    <div>
      <SideNavLayout>
        <div className="w-full flex justify-between">
          <div className="flex gap-4 items-center">
            <div
              onClick={() => setIsCalendarOpen(!isCalendarOpen)}
              className="flex items-center gap-3 px-6 py-2 shadow-md bg-white rounded-[36px] cursor-pointer"
            >
              {/* ◀ Previous */}
              <div
                onClick={handlePrevDate}
                className="cursor-pointer hover:opacity-70 transition"
              >
                {leftarrow}
              </div>

              {/* Date */}
              <div className="text-sm">
                <Typography variant="h6" sx={{ fontSize: "14px" }}>
                  {dayjs(showdate.current).format("MM-DD-YYYY")}
                </Typography>
              </div>
              <img
                className="w-5 h-5 ml-1"
                alt="Calendar Icon"
                src={calendericon}
              />
              {/* ▶ Next */}
              <div
                onClick={handleNextDate}
                className="cursor-pointer hover:opacity-70 transition"
              >
                {rightarrow}
              </div>

              {/* Calendar Icon */}
            </div>

            {/* <img style={{width:'28px',cursor:"pointer"}}   src={Filtericon} alt="$/"/> */}

            {/* <FilterAltIcon/> */}

            {/* OSA's build hid "Past Appt." (the Filter popup keeps it). */}
            {!b6.reportsSlim && (
            <div
              onClick={() => handlePreappointment("P")}
              className="mx-2 font-inter flex items-center py-2 flex border border-gray-300 rounded-md text-center justify-center cursor-pointer hover:bg-gray-100 whitespace-nowrap"
            >
              <FastRewindIcon />
              <span className="px-2 py-1 text-[#398439]"> Past Appt.</span>
            </div>
            )}
          

{/* Amount Buttons */}
    <div className="mx-2 flex items-center space-x-4">
      <span
        className="flex items-center space-x-2 bg-[#ffdcdc] text-[#f60000]  px-3 py-2 rounded-md cursor-pointer hover:bg-red-200 transition"
        id="1"
      >
        <PaymentIcon />
        <span id="rcard">${squareAmount.toFixed(2)}</span>
      </span>

      <span
        className="flex items-center space-x-2 bg-[#dbf0db] text-[#398439] px-3 py-2 rounded-md cursor-pointer hover:bg-green-200 transition"
        id="2"
      >
        <AttachMoneyIcon />
        <span id="rcash">${cashAmount.toFixed(2)}</span>
      </span>
    </div>

          </div>
          <div className="relative w-full max-w-md  flex justify-end">
            <div className="flex items-center w-[80%] bg-[#F5F6FA] border border-[#D5D5D5] m-[2px] rounded-[15px]">
              {/* Left-aligned search icon inside the input field */}
              <FontAwesomeIcon icon={faSearch} className="text-gray-400 ml-3" />
              {/* Search input field with reduced height */}
              <input
                type="text"
                className="bg-[#F5F6FA] flex-grow pl-2 pr-3 text-base outline-none rounded-[15px]"
                placeholder="Search"
                value={searchTerm} // Bind value to searchTerm
                onChange={(e) => setSearchTerm(e.target.value)} // Update searchTerm on input change
              />
            </div>
          </div>
        </div>
        <div className=" flex my-4 mb-1 justify-between">
          {/* Date Range Dropdown */}
          <div className="flex space-x-4 ">
            {/* <select
          id="date-range"
          value={dateRange}
          onChange={(e) => handleDateRangeSelect(e.target.value)}
          className="font-inter text-sm block w-[150px] px-2 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
        >
          <option value=""> Date Range</option>
          {dateRanges.map((range) => (
            <option key={range} value={range}>
              {range}
            </option>
          ))}
        </select> */}
            <div
              onClick={() => SetIsFilterPopup(true)}
              className="px-1 font-inter text-sm w-[80px] flex items-center py-2 flex border border-gray-300 rounded-md text-center justify-center cursor-pointer hover:bg-gray-100 whitespace-nowrap"
            >
              <img
                className="mr-1"
                style={{ width: "16px", cursor: "pointer" }}
                src={Filtericon}
                alt="$/"
              />
              <span> Filter</span>
            </div>
            {/* OSA batch 6: the printable Payment Report (OSA's "PDF"). */}
            {b6.paymentReportPdf && (
            <button
              type="button"
              onClick={handlePaymentReportPdf}
              disabled={!data.length || pdfBusy}
              data-testid="payment-report-pdf"
              className="px-3 font-inter text-sm flex items-center py-2 border border-gray-300 rounded-md text-center justify-center cursor-pointer hover:bg-gray-100 whitespace-nowrap disabled:opacity-40 disabled:cursor-not-allowed"
            >
              <svg className="mr-1 w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 10v6m0 0l-3-3m3 3l3-3m2 4H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
              </svg>
              PDF
            </button>
            )}
          </div>

          {/* Users Dropdown */}

          {/* Filter, Insurance, Self Pay Divs */}
          <div className="flex space-x-4">
            {/* Department filter — defaults to the user's department.
                Only for a practice with more than one location (9928). */}
            {hasMultipleDepartments() && <select
              value={deptFilter ?? ""}
              onChange={(e) => setDeptFilter(e.target.value === "" ? "" : Number(e.target.value))}
              className="px-2 py-1 border-[1.5px] border-gray-200 font-inter text-sm rounded-md cursor-pointer hover:border-[#E17954]"
            >
              {/* A CODE-tagged login sees only CODE (no "All departments"). */}
              {filterOffersAll(userConfig?.config) && <option value="">All departments</option>}
              {filterLocationsFor(userConfig?.config).map((d) => <option key={d.id} value={d.id}>{d.name}</option>)}
            </select>}
            {recordSearch && (
              <div
                onClick={handleClearClick}
                className="my-1  border flex items-center border-gray-300 font-inter text-sm rounded-md text-center hover:border-[#E17954] cursor-pointer hover:bg-gray-100"
              >
                <CloseIcon />
              </div>
            )}
           {paymentprev.includes('Delete Payment')&& <div
              onClick={() => setIsDeletedRecords((prev) => !prev)}
              className={`px-2 py-1 flex items-center font-inter text-sm rounded-md cursor-pointer
  ${isdeletedRecords ? "border-[#E17954] border-[1.5px]" : "border-gray-200 border-[1.5px] hover:border-[#E17954] hover:bg-gray-100"}`}
            >
              Deleted
            </div>}
            <div
              onClick={() => handleRecordSearchClick("insurance")}
              className={`px-2 py-1  flex items-center font-inter text-sm rounded-md text-center cursor-pointer
    ${recordSearch === "insurance" ? "border-[#E17954] border-[1.5px]" : "hover:border-[#E17954] border-[1.5px] border-gray-200 hover:bg-gray-100"}`}
            >
              Insurance
            </div>
            <div
              onClick={() => handleRecordSearchClick("selfpay")}
              className={`px-2 py-1  flex items-center font-inter text-sm rounded-md text-center cursor-pointer
        ${recordSearch === "selfpay" ? "border-[#E17954] border-[1.5px]" : "hover:border-[#E17954] border-[1.5px] border-gray-200 hover:bg-gray-100"}`}
            >
              Self Pay
            </div>

            <div>
              <select
                id="user"
                value={selectedUser}
                onChange={(e) => handleUserChange(e.target.value)} // Trigger handleUserChange
                className="block font-inter text-sm w-full px-2 py-[9px] border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
              >
                <option value="">Select User</option>
                {userList.map((user, index) => (
                  <option key={user.id} value={user.id}>
                    {" "}
                    {/* Use user.id directly */}
                    {user.firstname} {user.lastname}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>

        {/* FILTER CHIPS */}
        <div className="flex flex-wrap gap-2 mt-2">
          {buildFilterChips().map((chip, index) => (
            <div
              key={index}
              className="flex items-center bg-[#EEF2FF] border border-[#C7D2FE] text-sm px-3 py-1 rounded-full"
            >
              <span>{chip.label}</span>

              <CloseIcon
                onClick={() => removeChip(chip)}
                sx={{ fontSize: 16, marginLeft: "6px", cursor: "pointer" }}
              />
            </div>
          ))}
        </div>

        <Reporttable
          data={data}
          totalData={totalData}
          setloading={setLoading}
          loading={loading}
          fetchMethdata={fetchMethdata}
          handleCheckLocaClick={handleCheckLocaClick}
          handleCheckMethodClick={handleCheckMethodClick}
          checkLoca={checkLoca}
          checkMethod={checkMethod}
          setpaymentModal={setpaymentModal}
          setSelectedCard={setSelectedCard}
          onclearfilters={onclearfilters}
          handledelete={handledelete}
          isdeletedRecords={isdeletedRecords}
          isRequested={isRequested}
          setIsRequested={setIsRequested}
          handlerequest={handlerequest}
          slim={b6.reportsSlim}
        />

        {isCalendarOpen && (
          <>
            <div
              ref={calendarRef}
              className="fixed top-[10%] left-0 sm:top-[22%] sm:left-[10%] z-50 w-[300px] bg-white  shadow-lg rounded-xl"
            >
              <DateRangeSelector
                onSubmit={handledateSelect} // This should be triggered when the Apply button is clicked
                selectedDateRange={selectedDateRange}
                setSelectedDateRange={setSelectedDateRange}
              />
            </div>
          </>
        )}
        <Filtermodal
          isOpen={filterPopup}
          onclosemodal={CloseFiltermodal}
          handleCheckLocaClick={handleCheckLocaClick}
          handleCheckMethodClick={handleCheckMethodClick}
          handleCheckStaClick={handleCheckStaClick}
          handlePreappointment={handlePreappointment}
          checkLoca={checkLoca}
          checkSta={checkSta}
          checkMethod={checkMethod}
          onclearfilters={onclearfilters}
          onapplyfilters={onapplyfilters}
          preAppointments={preAppointments}
            isRequested={isRequested}
          setIsRequested={setIsRequested}

        />
        <Backdrop
          sx={{
            color: "secondary.main", // Sets the CircularProgress color to secondary
            backgroundColor: "rgba(255, 255, 255, 0.5)", // Semi-transparent white background
            zIndex: (theme) => theme.zIndex.drawer + 1,
          }}
          open={loading || deleteloading}
        >
          <CircularProgress color="secondary" />
        </Backdrop>
        <ReportPaymentModal
          isOpen={paymentModal}
          data={selectedcard}
          updatedata={updatedata}
          onClose={ClosePaymentModal}
        />
        {/* {paymentModal?<Payments 
                      data={selectedcard} alldata={[selectedcard]}
                       fetchdata={()=>{}} isOpen={paymentModal} 
                       flow={'reports'}
                       updatedata={updatedata}
                         ClosePaymentModal={ClosePaymentModal}/>:<></>} */}
      </SideNavLayout>
    </div>
  );
};

export default Reporthome;
